// Behavioral constants ported from the iOS app (CombinedMapView.Constants,
// GaugeManager, FloodDataManager). Distances are "camera distance" in meters,
// the MapKit notion the iOS thresholds are written in. See cameraDistance.ts
// for how the web derives the same number from the MapLibre viewport.

export const METERS_PER_DEGREE_LAT = 111_000;

export const CAMERA = {
  /** Continental US on launch (CombinedMapView.swift 98-101). */
  defaultCenter: { lat: 39.8, lng: -98.6 },
  defaultDistance: 10_000_000,
  /** First user fix animates once to this region (160,934 / 8, about 12.5 miles). */
  initialUserZoomMeters: 160_934 / 8,
  /** "Center on user" control and "Navigate to Location" both use a 10 km region. */
  centerOnUserMeters: 10_000,
  /** Locate button in an alert row shows a 50 km region around the centroid. */
  locateAlertMeters: 50_000,
  minDistance: 2_500,
  maxDistance: 100_000_000,
  /** All camera-driven work waits this long after the camera settles. */
  debounceMs: 300,
  fimMaxVisibilityDistance: 100_000,
  fimStrokeMaxDistance: 50_000,
  minFIMSpanDegrees: 0.05,
  maxGaugeFetchDistance: 2_000_000,
  maxStationDisplayDistance: 2_000_000,
  crestLabelVisibilityDistance: 1_000_000,
  thcMaxDistance: 5_800_000,
  thcStrokeMaxDistance: 500_000,
  /** Minimum screen distance between alert icons before they merge. */
  iconMinimumSpacingPx: 56,
} as const;

/** MapLibre zoom bounds. iOS limits camera distance instead; see docs/DECISIONS.md. */
export const MAP = {
  style: 'https://tiles.openfreemap.org/styles/liberty',
  minZoom: 3,
  maxZoom: 17,
  maxBounds: [[-180, 10], [-50, 75]] as [[number, number], [number, number]],
} as const;

/** iOS asset catalog palette (light appearance). */
export const PALETTE = {
  cobalt: '#4a57db',
  mist: '#fafafa',
  charcoal: '#171717',
  glacier: '#45b8e8',
  rainwater: '#4787e3',
} as const;

export const TOAST_MS = 3_000;

/** Bottom sheet detents (InterfaceExplorerView.swift 128-143, 578-581). */
export const SHEET = {
  smallPx: 110,
  mediumFraction: 0.5,
  largeFraction: 0.9,
} as const;
